import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type GeoAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatGeoToastLabel(code: string | undefined): string {
    const t = typeof code === "string" ? code.trim() : "";
    return t.length > 0 ? t : EntityLabels.geography;
}

export function getGeoAdminActionSuccessMessage(
    kind: GeoAdminConfirmKind,
    code: string | undefined
): string {
    const label = formatGeoToastLabel(code);
    const successByKind: Record<GeoAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type GeoRow = { id: string; code: string };

export const buildGeoAdminPagedListActions = (openConfirm: (kind: GeoAdminConfirmKind, item: GeoRow) => void) =>
    buildRecordLifecyclePagedListActions<GeoRow>(openConfirm, { activeMember: "isActive" });
